import React from 'react';
import { useTranslation } from '../../../../../core';
import { AccountStatusButtons } from '../AccountStatusButtons';
import { DetailsSection } from '../DetailsSection';
import { IntegrationDetailsFields } from '../IntegrationDetailsFields';
import { IntegrationDetailsFooter } from '../IntegrationDetailsFooter';
import { IntegrationMigrationActions } from '../IntegrationMigrationActions';

/**
 * Renders blocking controls and marketplace-specific administration actions.
 *
 * @param {object} props
 * @param {string} props.companyId
 * @param {Array<object>} props.fields
 * @param {boolean} props.hasChanges
 * @param {object} props.integration
 * @param {boolean} props.isSaving
 * @param {Function|null} props.onClose
 * @param {Function|null} props.onSave
 * @param {object} props.updatedData
 */
export const AdministrationTab = ({
    companyId,
    fields = [],
    hasChanges = false,
    integration,
    isSaving = false,
    onClose = null,
    onSave = null,
    updatedData
}) => {
    const { t } = useTranslation();

    return (
        <div>
            <DetailsSection title={t('integrations.blockingSettings')}>
                <IntegrationDetailsFields
                    fields={fields}
                    integration={integration}
                    isSingleColumn={true}
                    updatedData={updatedData}
                />
            </DetailsSection>
            <AccountStatusButtons companyId={companyId} account={integration} />
            <IntegrationMigrationActions companyId={companyId} integration={integration} />
            <IntegrationDetailsFooter
                hasUpdated={hasChanges}
                isSaving={isSaving}
                onClose={onClose}
                onSave={onSave}
            />
        </div>
    );
};
